import { render } from "./Vault.vue?vue&type=template&id=09d05c92&scoped=true&ts=true"
import script from "./Vault.vue?vue&type=script&lang=tsx"
export * from "./Vault.vue?vue&type=script&lang=tsx"

import "./Vault.vue?vue&type=style&index=0&id=09d05c92&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d05c92"]])

export default __exports__